import { useForm } from 'react-hook-form';
import type { HistoryDateFilter, Language } from '@/shared/types';
import type { FileType, GenerateStatementFormValues } from './types';
import { getDefaultFormValues } from '../lib';

type Props = {
  language: Language;
  dateFilter?: HistoryDateFilter;
  dateFrom?: Date;
  dateTo?: Date;
  fileType?: FileType;
  formValues?: GenerateStatementFormValues;
};

const useGenerateStatementForm = ({
  language,
  dateFilter,
  dateFrom,
  dateTo,
  fileType,
  formValues,
}: Props) => {
  const form = useForm<GenerateStatementFormValues>({
    mode: 'onChange',
    defaultValues: getDefaultFormValues(
      language,
      dateFilter,
      dateFrom,
      dateTo,
      fileType,
      formValues
    ),
  });

  const fileTypeValue = fileType ?? form.watch('fileType');

  return {
    form,
    fileTypeValue,
  };
};

export { useGenerateStatementForm };
